import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchInput from '../../../../components/inputs/SearchInput';
import styles from './UnitHeader.styles';
import TrainIcon from '@mui/icons-material/Train';

export default function UnitHeader({ onSearch, searchQuery, setSearchQuery }) {
  return (
    <Box sx={styles.headerRow}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <TrainIcon sx={{ ...styles.pageTitle, mr: 1 }} />
        <Typography sx={styles.pageTitle}>Units</Typography>
      </Box>

      <SearchInput
        value={searchQuery}
        onChange={setSearchQuery}
        onSearch={onSearch}
      />
    </Box>
  );
}
